/**
 * DANH MUC ACTION NHAT KY — docs/07-bao-mat-xac-thuc.md §7.8.
 *
 * "Danh sach `action` chuan — khong tu dat ten khac."
 * Moi ghi nhat ky di qua ham duy nhat `audit(action, actorId, target, meta)`.
 */

export const AUDIT_ACTIONS = [
  // auth
  'auth.login',
  'auth.login_failed',
  'auth.logout',
  'auth.new_device',
  'auth.password_reset',
  'auth.2fa_enabled',
  'auth.2fa_disabled',
  'auth.recovery_used',

  /*
   * OQ-330 — passkey. Ba việc đáng ghi lại, và một việc CỐ Ý không ghi.
   *
   * Ghi: thêm khoá mới, gỡ khoá, và đăng nhập bằng khoá. Ba việc này đổi được
   * ai vào được tài khoản, nên phải có vết.
   *
   * Không ghi riêng: đổi TÊN một khoá. Tên chỉ để người dùng phân biệt máy của
   * mình; ghi nó vào nhật ký bất biến là làm loãng đúng thứ nhật ký sinh ra để
   * theo dõi.
   */
  'auth.passkey_added',
  'auth.passkey_removed',
  'auth.passkey_login',

  // user
  'user.invite',
  'user.create',
  'user.update',
  'user.role_change',
  'user.suspend',
  'user.delete',
  'user.force_2fa',
  'user.sessions_revoked',

  // domain
  'domain.create',
  'domain.update',
  'domain.delete',
  'domain.sync',
  'domain.transfer',
  'domain.pause',
  'domain.purge_cache',
  'domain.ns_verify',

  // dns
  'dns.create',
  'dns.update',
  'dns.delete',
  'dns.proxy_toggle',
  'dns.import',
  'dns.export',
  'dns.sync_removed',

  // grant
  'grant.create',
  'grant.update',
  'grant.revoke',
  'grant.invite',

  // sub-domain (OQ-291)
  'subdomain.create',
  'subdomain.delete',
  'subdomain.grant',
  'subdomain.grant_update',
  'subdomain.revoke',

  // role
  'role.create',
  'role.update',
  'role.delete',
  'role.reset',

  // domain role
  'domainrole.create',
  'domainrole.update',
  'domainrole.delete',

  // connection
  'connection.create',
  'connection.update',
  'connection.verify',
  'connection.rotate',
  'connection.set_default',
  'connection.pause',
  'connection.delete',

  // setting
  'setting.update',
  'setting.smtp_test',

  // kho sao luu ngoai (OQ-294)
  'backup.remote_add',
  'backup.remote_update',
  'backup.remote_connect',
  'backup.remote_check',
  'backup.remote_remove',

  /*
   * OQ-337 — Cloudflare Tunnel.
   *
   * `tunnel.token_view` la mot action DOC, khac ba cai kia. No co mat vi thu
   * duoc doc la token cai dat: bat ky ai cam chuoi do deu bien duoc may cua ho
   * thanh loi ra cua tunnel. Doc mot bi mat co hau qua ngang voi sua no, nen
   * no phai de lai vet — dung nhu `auth.recovery_used`.
   */
  'tunnel.create',
  'tunnel.delete',
  'tunnel.token_view',
  'tunnel.config_update',
] as const;

export type AuditAction = (typeof AUDIT_ACTIONS)[number];

const AUDIT_ACTION_SET = new Set<string>(AUDIT_ACTIONS);

export function isKnownAuditAction(action: string): action is AuditAction {
  return AUDIT_ACTION_SET.has(action);
}

/** audit_logs.target_type — docs/03 §3.2. */
export const AUDIT_TARGET_TYPES = [
  'domain',
  'user',
  'connection',
  'role',
  'domainrole',
  'setting',
  'session',
  'grant',
  'dns',
  'subdomain',
] as const;

export type AuditTargetType = (typeof AUDIT_TARGET_TYPES)[number];

/** audit_logs.result — docs/03 §3.2. */
export const AUDIT_RESULTS = ['success', 'failure'] as const;
export type AuditResult = (typeof AUDIT_RESULTS)[number];

/**
 * Truong nhay cam bi loai bo truoc khi ghi log/audit — docs/07 §7.6.
 * "Bo loc log phai loai bo khoa: password, apiToken, token, secret,
 *  recoveryCodes, authorization, cookie".
 */
export const REDACTED_KEYS = [
  'password',
  'apiToken',
  'token',
  'secret',
  'recoveryCodes',
  'authorization',
  'cookie',
] as const;

export const REDACTED_PLACEHOLDER = '[REDACTED]';
